import type { Collection } from "../types/product";

export const collections: Collection[] = [
  {
    slug: "royal-honey",
    name: "Honey & Choco",
    description: "Fast-acting aphrodisiac honey sachets and chocolate.",
    image: "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/06/1-2.png?w=900&ssl=1",
  },
  {
    slug: "seven-sins",
    name: "Seven Sins",
    description: "Elevate your energy, explore your desires.",
    image: "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/01/seven-sins-master-side-content-2.jpg?w=900&ssl=1",
  },
  {
    slug: "devils-candy",
    name: "Devils Candy",
    description: "Jellies, gels and creams to set the mood.",
    image: "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/Devils-Candy-Oral-Jelly-1.jpg?w=900&ssl=1",
  },
  {
    slug: "high-octane",
    name: "High Octane",
    description: "Powerful oral gels for him and her.",
    image: "https://i0.wp.com/rise-upp.com/wp-content/uploads/2025/02/High-Octane-Raptor-3.jpg?w=900&ssl=1",
  },
];
